export abstract class PersistentTokenStorage {
    abstract getToken(): string | null;
    abstract setToken(token: string): void;
    abstract getRefreshToken(): string | null;
    abstract setRefreshToken(refreshToken?: string): void;
    abstract clear(): void;
}
